export type ToastVariant = 'success' | 'error';

type ToastHandler = (message: string, variant: ToastVariant) => void;

let handler: ToastHandler | null = null;

/** Called once by <ToastProvider/> in main.tsx to wire itself up. */
export function registerToastHandler(fn: ToastHandler | null): void {
  handler = fn;
}

/** Show a toast notification — the confirmation feedback after a CRUD action completes. */
export function showToast(message: string, variant: ToastVariant = 'success'): void {
  handler?.(message, variant);
}
